import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import Card, { CardHeader, CardBody } from '@/components/ui/Card';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Badge from '@/components/ui/Badge';

export default function DistPlatformDetailPage() {
  const { id: _id } = useParams();

  return (
    <div className="space-y-6 animate-fade-in">
      <Link to="/distribution/platforms" className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-700">
        <ArrowLeftIcon className="w-4 h-4" />
        Back to Platforms
      </Link>

      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">🍎 Apple Books</h1>
          <Badge variant="success" className="mt-2">Active</Badge>
        </div>
        <Button>Save Configuration</Button>
      </div>

      <Card>
        <CardHeader title="Connection Settings" />
        <CardBody className="space-y-4">
          <Input label="API Endpoint" placeholder="https://api.apple.com/books" />
          <Input label="API Key" type="password" placeholder="••••••••" />
          <Input label="Publisher ID" placeholder="123456789" />
        </CardBody>
      </Card>

      <Card>
        <CardHeader title="Delivery Options" />
        <CardBody className="space-y-4">
          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
            <div>
              <p className="font-medium">Auto-publish on validation</p>
              <p className="text-sm text-slate-500">Automatically publish books when validation passes</p>
            </div>
            <input type="checkbox" className="toggle" />
          </div>
          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl">
            <div>
              <p className="font-medium">Send notifications</p>
              <p className="text-sm text-slate-500">Receive email notifications on delivery status</p>
            </div>
            <input type="checkbox" className="toggle" defaultChecked />
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

